import { defineMessages } from 'react-intl';

export default defineMessages({
  ariaLabel: {
    id: 'neptune.Chips.ariaLabel',
    defaultMessage: 'Clear {choice}',
    description: 'Clear button for chip',
  },
});
